module.exports = __webpack_public_path__ + "media/images/hortense-for-wedding/potage-33336fea499011357c2599b0dedda4a6.png";